import React, {useContext, useEffect, useState} from "react";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import {useIntl} from "react-intl";
import {NotificationsContext} from "../ui-components/Notifications";
import ColorCollectionGrid from "./ColorCollectionGrid";
import Spinner from "../ui-components/Spinner";
import Modal from "../ui-components/Modal";
import Button from "../ui-components/Button";
import {PencilSquareIcon} from "@heroicons/react/24/outline";
import ColorPreviewBox from "@ui-components/ColorPreviewBox";

const ConfiguratorSurveyKCCSelector = ({ value=null, onChange=() => {}, disabled=false}) => {

  const intl = useIntl();
  const countryApiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);

  const [colors, setColors] = useState();
  const [isModalOpen, setIsModelOpen] = useState(false);
  const [selectedModalColor, setSelectedModalColor] = useState(value);

  const selectedColorRGB = colors?.find((c) => c.code === value)?.rgb;

  useEffect(() => {
    countryApiRequest.get('/tintometers/colors/all', {params: {id_collection: 1}})
      .then((res) => { setColors(res); })
      .catch((err) => {
        push({type: 'error', title: intl.formatMessage({id: 'an_error_occurred'})});
        throw err;
      })
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSelectedModalColor(value);
    setIsModelOpen(false);
  }, [value]);  // eslint-disable-line react-hooks/exhaustive-deps

  return <>
    <div className="flex gap-5 my-3">
      <div>
        {/*<div className="w-28 mb-2 rounded" style={{aspectRatio: '16 / 9', ...selectedColorBackgroundCSS}} />*/}
        <ColorPreviewBox
          selectedColorRGB={selectedColorRGB}
          className="w-28 mb-2 rounded"
        />
        <Button
          full
          paddingCls="px-1 py-0.5"
          onClick={() => { setIsModelOpen(true); }}
          disabled={disabled}
        >
          <PencilSquareIcon className="w-3" />
          <span className="text-xs">{intl.formatMessage({id: 'edit'})}</span>
        </Button>
      </div>
      <p className={`text-lg mt-4 ${!!value ? 'font-bold' : 'font-light'}`}>
        {
          !!value
            ? 'KK ' + value.slice(2)  // 'KK12' --> 'KK 12'
            : intl.formatMessage({id: 'no_color_selected'})
        }
      </p>
    </div>
    {
      isModalOpen && (
        <Modal
          large
          onConfirm={() => { onChange(selectedModalColor); }}
          onDismiss={() => { setIsModelOpen(false); }}
          onExit={() => { setIsModelOpen(false); }}
          confirmText={intl.formatMessage({id: 'confirm'})}
          dismissText={intl.formatMessage({id: 'cancel'})}
        >
          <h1 className="text-center text-xl font-extrabold">
            {intl.formatMessage({id: 'select_kcc_color'})}
          </h1>
          <p className="py-5">
            {intl.formatMessage({id: 'select_kcc_color_helper'})}
          </p>
          {
            colors
              ? <div className="overflow-x-auto bg-gray-100 px-6 py-4 rounded-xl shadow w-full">
                <ColorCollectionGrid
                  onColorClick={(c) => { setSelectedModalColor(selectedModalColor !== c ? c : null); }}
                  selected={selectedModalColor}
                  containerStyle={{minHeight: '500px', margin: 'auto', width: 'fit-content'}}
                  {...{colors}}
                />
              </div>
              : <Spinner />
          }
        </Modal>
      )
    }
  </>
}

export default ConfiguratorSurveyKCCSelector;